/**
 * Calidad automática: mide los fps y, si no llegan a ~50, baja la resolución interna del render
 * (pixel ratio) por pasos. Si aun así no llega a 40, quita los detalles (bruma y luciérnagas).
 * Cuando sobra rendimiento durante un rato, vuelve a subirla.
 */
const WINDOW = 2; // segundos por medición
const MIN_RATIO = 1;
const STEP = 0.25;

export class Quality {
  constructor(renderer, environment) {
    this.renderer = renderer;
    this.env = environment;
    this.max = Math.min(window.devicePixelRatio || 1, 2);
    this.ratio = this.max;
    this.frames = 0;
    this.elapsed = 0;
    this.goodWindows = 0;
    this.sinceChange = 0;
    this.fps = 0;
    this.skip = 1; // ventanas a ignorar (arranque, vuelta de segundo plano)
    renderer.setPixelRatio(this.ratio);
  }

  /** Tras una pausa o un cambio de pestaña las primeras medidas no son fiables. */
  reset() {
    this.frames = 0;
    this.elapsed = 0;
    this.skip = 1;
  }

  update(dt) {
    this.frames++;
    this.elapsed += dt;
    this.sinceChange += dt;
    if (this.elapsed < WINDOW) return;
    this.fps = this.frames / this.elapsed;
    this.frames = 0;
    this.elapsed = 0;
    if (this.skip > 0) {
      this.skip--;
      return;
    }

    if (this.fps < 50) {
      this.goodWindows = 0;
      if (this.ratio > MIN_RATIO) this.#set(Math.max(MIN_RATIO, this.ratio - STEP));
      else if (this.fps < 40 && !this.env.lowDetail) this.env.setLowDetail(true);
    } else if (this.fps > 58) {
      this.goodWindows++;
      // Solo se sube tras 10 s fluidos y si hace rato del último cambio (evita oscilar).
      if (this.goodWindows >= 5 && this.sinceChange > 20 && this.ratio < this.max) {
        this.#set(Math.min(this.max, this.ratio + STEP));
        this.goodWindows = 0;
      }
    }
  }

  #set(ratio) {
    this.ratio = ratio;
    this.sinceChange = 0;
    this.skip = 1;
    this.renderer.setPixelRatio(ratio);
  }

  get label() {
    return `${this.ratio.toFixed(2)}x${this.env.lowDetail ? ' (bajo)' : ''}`;
  }
}
